// extracted by mini-css-extract-plugin
export var indeterminate = "_4i-6";
export var md = "_4i-5";
export var semantic = "_4i-7";
export var sm = "_4i-4";
export var text = "_4i-8";
export var toggleControl = "_4i-0";
export var toggleInput = "_4i-1";
export var toggleSwitch = "_4i-2";
export var xs = "_4i-3";